export default [
  {
    w: 3,
    h: 16,
    x: 0,
    y: 0,
    i: 'popular-81735522335293475546087951289435',
  },
  {
    w: 3,
    h: 11,
    x: 3,
    y: 5,
    i: 'todo-53084247679600442035440807237732',
  },
  {
    w: 3,
    h: 5,
    x: 7,
    y: 0,
    i: 'guide-94488587319007026057257701564270',
  },
  {
    w: 4,
    h: 5,
    x: 3,
    y: 0,
    i: 'clock-91762259068903857266015365889488',
  },
  {
    w: 6,
    h: 11,
    x: 6,
    y: 5,
    i: 'column-00186412708682371166740249850082',
  },
  {
    w: 2,
    h: 5,
    x: 10,
    y: 0,
    i: 'ring-86085426727800785417310093605893',
  },
];
